import React, { createContext, useContext, useReducer, useState, useEffect } from 'react';
import { settingsReducer, initialSettings } from './settings/settingsReducer';
import useActiveSinkId from './useActiveSinkId';
export const TwilioStateContext = createContext();
import { sanitizeSettings } from '../utils';

export default function TwilioAppStateProvider(props) {
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState(props.error);
    const [settings, dispatchSetting] = useReducer(settingsReducer, initialSettings);
    const [activeSinkId, setActiveSinkId] = useActiveSinkId();
    const [isPermissionToDevices, setIsPermissionToDevices] = useState(false);


    useEffect(() => {
        if (props.isFetching === false) {
            setIsFetching(false);
        }
        else
            setIsFetching(true);

    }, [props.isFetching]);

    useEffect(() => {
        if (props.isPermissionToDevices === false) {
            setIsPermissionToDevices(false);
        }
        else
            setIsPermissionToDevices(true);

    }, [props.isPermissionToDevices]);

    useEffect(() => {
        if (props.error) {
            setError(props.error);
        }
        else
            setError(null);

    }, [props.error]);

    let contextValue = {
        error,
        setError,
        isFetching,
        setIsFetching,
        appointmentDetails: props.appointmentDetails,
        twilioToken: props.token,
        roomName: props.roomName,
        source: props.source,
        onConnected: props.onConnected,
        onError: props.onError,
        isFromNonLogin: props.isFromNonLogin,
        settings,
        activeSinkId,
        setActiveSinkId,
        isSDCVisit: props.isSDCVisit,
        onTwilioEndCall: props.onTwilioEndCall,
        isPermissionToDevices: props.isPermissionToDevices,
        twilioUserName: props.twilioUserName,
        onTwilioRoomError: props.onTwilioRoomError,
        _isMounted: props._isMounted,
        twilioSettings: null,
        localParticipantRole: props.localParticipantRole
    };
    
    if (props.twilioSettings && props.twilioSettings.twilioConnectSettings) {
        try {
            contextValue = {
                ...contextValue,
                twilioSettings: props.twilioSettings.isDynamicSettings ? { settings: sanitizeSettings(props.twilioSettings.twilioConnectSettings), isDynamicSettings: props.twilioSettings.isDynamicSettings
                } : { settings: props.twilioSettings.twilioConnectSettings, isDynamicSettings: props.twilioSettings.isDynamicSettings }                   
            }
        }
        catch (err) {
            console.log(err);
            contextValue = {
                ...contextValue,
                twilioSettings: null
            }
        }
    }
        
    

    if (typeof window !== "undefined" && props.source && (typeof window.twilioSource === 'undefined' || (typeof window.twilioSource !== 'undefined' && window.twilioSource !== props.source))) {
        window.twilioSource = props.source;
        console.log("Twilio Source: " + window.twilioSource);
    }

    return <TwilioStateContext.Provider value={{ ...contextValue }}>{props.children}</TwilioStateContext.Provider>;
}

export function useTwilioAppState() {
    const context = useContext(TwilioStateContext);
    if (!context) {
        throw new Error('useTwilioAppState must be used within the TwilioAppStateProvider');
    }
    return context;
}
